export const authScreens = {
  accesoDirecto: {
    loading: "جارٍ تسجيل الدخول إلى الحساب…",
  },
  confirmar: {
    verifying: "جارٍ التحقق من الحساب…",
    verifiedSuccess: "تم التحقق من الحساب بنجاح",
    tokenInvalid: "الرمز غير موجود أو انتهت صلاحيته",
    backHome: "العودة إلى الصفحة الرئيسية",
  },
  recovery: {
    title: "استعادة كلمة المرور",
    successTitle: "تم بنجاح!",
    successDesc:
      "تم تغيير كلمة المرور بنجاح. جارٍ إعادة توجيهك إلى البداية…",
    infoTitle: "أنشئ كلمة مرور جديدة",
    infoDesc:
      "عند تغييرها، سيتم إنهاء جميع الجلسات النشطة على أجهزتك الأخرى.",
    newPasswordLabel: "كلمة المرور الجديدة",
    newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
    togglePasswordAria: "إظهار/إخفاء كلمة المرور",
    confirmPasswordLabel: "إعادة إدخال كلمة المرور",
    confirmPasswordPlaceholder: "أعد إدخال كلمة المرور الجديدة",
    passwordsMismatch: "كلمتا المرور غير متطابقتين.",
    submit: "تغيير كلمة المرور",
    submitting: "جارٍ المعالجة…",
    backToStart: "العودة إلى البداية",
    footerWeb: "الموقع الإلكتروني",
    toastInvalidLink: "رابط الاستعادة غير صالح أو انتهت صلاحيته.",
    errorGeneric: "تعذّر تغيير كلمة المرور.",
  },
};
